import FooterContainer_BlankScreenComponent from '@wix/thunderbolt-elements/src/components/FooterContainer/viewer/skinComps/BaseScreen/BlankScreen.skin';


const FooterContainer_BlankScreen = {
  component: FooterContainer_BlankScreenComponent
};


export const components = {
  ['FooterContainer_BlankScreen']: FooterContainer_BlankScreen
};

